




















































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import Api from '@/api/distributor/withdrawLogs/index'
@Component({
  components: {
    CustomForm
  }
})
export default class Reconciliation extends AbpBase {
  filters = [
    {
      label: '提现编号',
      type: 'input',
      props: {
        placeholder: '请输入提现编号'
      },
      key: 'tradeNo'
    },
    {
      label: '金额范围',
      type: 'select',
      props: {
        placeholder: '请输入金额范围'
      },
      key: 'amountRange',
      options: [
        {
          value: '0~100',
          text: '0~100'
        },
        {
          value: '100~200',
          text: '100~200'
        },
        {
          value: '200~300',
          text: '200~300'
        },
        {
          value: '300~100000',
          text: '300以上'
        }
      ]
    },
    {
      label: '对账状态',
      type: 'select',
      props: {
        placeholder: '请选择对账状态'
      },
      key: 'checkStatus',
      options: [
        {
          value: 0,
          text: '未对账'
        },
        {
          value: 1,
          text: '已对账'
        },
        {
          value: 2,
          text: '异常'
        },
        {
          value: 3,
          text: '冲正'
        }
      ]
    }
  ]
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '提现编号',
      key: 'tradeNo'
    },
    {
      title: '提现金额',
      key: 'withdrawnCash'
    },
    {
      title: '支付时间',
      key: 'payTime',
      slot: 'payTime'
    },
    {
      title: '对账人员',
      key: 'checker'
    },
    {
      title: '对账时间',
      key: 'checkTime',
      slot: 'checkTime'
    },
    {
      title: '状态',
      key: 'checkStatus',
      slot: 'checkStatus'
    }
    // {
    //   title: '操作',
    //   key: 'action',
    //   slot: 'action'
    // }
  ]
  data = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0
  }
  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      this.loadData(form)
    }
  }
  checkStatusDisplayName(status) {
    switch (status) {
      case 0:
        return '未对账'
      case 1:
        return '已对账'
      case 2:
        return '异常'
      case 3:
        return '已冲正'
      default:
        return ''
    }
  }
  view(id) {
    this.$router.push({ name: 'reconciliationDetail' })
  }
  updateCheckStatus(checkStatus: number) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length <= 0) {
      this.$Message.warning('请选择提现记录')
    }
    let ids = selection.map(t => t.id)
    Api.updateCheckStatus({
      ids: ids,
      checkStatus: checkStatus,
      remark: ''
    }).then(res => {
      this.$Message.success('操作成功')
      this.loadData((this.$refs.lineForm as any).form)
    })
  }
  loadData(form = {}) {
    let tradeNo = form['tradeNo']
    let range = form['amountRange']
    let upper = null
    let lower = null
    if (range) {
      var arr = range.split('~')
      lower = arr[0]
      upper = arr[1]
    }
    let checkStatus = form['checkStatus']
    Api.getList(
      this.pager.pageSize,
      this.pager.pageIndex,
      tradeNo,
      upper,
      lower,
      checkStatus
    ).then(res => {
      this.pager.total = res.data.totalCount
      this.data = res.data.items
    })
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData((this.$refs.lineForm as any).form)
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  setSuccess() {
    this.updateCheckStatus(1)
  }
  setException() {
    this.updateCheckStatus(2)
  }
  setAverage() {
    this.updateCheckStatus(3)
  }
}
